import { TemplateKey } from "PFApp/constants/templates";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { LoadingDots } from "PFComponents/loading_dots";
import { useActivity } from "PFCore/hooks/queries/activity";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { FormMode } from "./activity_form.types";
import { ActivityFormPage } from "./activity_form_page";

type ActivityFromControllerProps = {
  mode: FormMode;
};

type ActivityEditPageParams = {
  id?: string;
  templateType?: TemplateKey;
};

export const ActivityFormController = ({ mode }: ActivityFromControllerProps) => {
  const { t } = useTranslation("activities");
  const { showGrowl } = useGrowlStoreActions();
  const navigate = useNavigate();

  const { id, templateType } = useParams<ActivityEditPageParams>();

  const {
    data: activityToClone,
    error: activityToCloneError,
    errorUpdatedAt
  } = useActivity(id!, {
    enabled: !!id
  });

  useEffect(() => {
    if (activityToCloneError) {
      showGrowl({
        message: t("form.errors.activityToCloneFetchError"),
        kind: "error"
      });
      navigate("/");
    }
  }, [errorUpdatedAt]); // eslint-disable-line react-hooks/exhaustive-deps

  switch (mode) {
    case FormMode.New: {
      return <ActivityFormPage type={templateType} />;
    }
    case FormMode.Edit: {
      return <ActivityFormPage id={id} />;
    }
    case FormMode.Clone: {
      if (activityToClone) {
        return <ActivityFormPage type={templateType} attributes={activityToClone} isClone />;
      } else {
        return <LoadingDots circlesEnabled pageViewEnabled />;
      }
    }
  }
};
